import React, { useEffect, useState } from 'react';
import './ManageRecipe.css';
import { useAdminContext } from '../../context/AdminContext';
import AddRecipe from './AddRecipe/AddRecipe';

const ManageRecipe = () => {
  const { fetchRecipes } = useAdminContext();
  const [recipes, setRecipes] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);

  useEffect(() => {
    const load = async () => {
      const data = await fetchRecipes();
      setRecipes(data);
    };
    load();
  }, [showAddForm]); // refresh when form closes

  return (
    <div className="manage-recipe">
      <div className="recipe-header">
        <h2>Manage Recipes</h2>
        <button className="add-btn" onClick={() => setShowAddForm(true)}>+ Add Recipe</button>
      </div>

      <div className="recipe-list">
        {recipes.length === 0 ? (
          <p>No recipes added yet.</p>
        ) : (
          recipes.map(recipe => (
            <div key={recipe.id} className="recipe-card">
              <img src={recipe.image} alt={recipe.title} />
              <div>
                <h3>{recipe.title}</h3>
                <p>{recipe.short}</p>
                <small>Calories: {recipe.nutritionalValues?.calories} kcal</small>
              </div>
            </div>
          ))
        )}
      </div>

      {showAddForm && (
        <AddRecipe
          onClose={() => setShowAddForm(false)}
          onSuccess={() => console.log("Recipe added")}
        />
      )}
    </div>
  );
};

export default ManageRecipe;
